import { where, orderBy, FieldPath } from '../firebase';

export const tenantQueryConstraints = (tenantId: string) => [where('tenantId', '==', tenantId)];

export const forwardMatchingQueryConstraints = (fieldPath: string | FieldPath, text: string) => [
  where(fieldPath, '>=', text),
  where(fieldPath, '<=', text + '\uf8ff'),
  orderBy(fieldPath, 'asc'),
];
